import React from 'react';
import "./footer.css"
import usa from"../../imag/icon/16.png"
const Footer = () => {
    return (
        <footer className="footer-wrapper">
            <div className="container">
                <div className="upper-text-container">
                <p>1. Trade-in values will vary based on the condition, year, and configuration of your el
                igible trade-in device. Not all devices are
                 eligible for credit. You must be at least 18 years old to be eligible to trade in for cr
                 edit or for an Apple Gift Card. Trade-in value may be applied toward qualifying new devic
                 e purchase, or added to an Apple Gift Card. Actual value awarded is based on receipt of a 
                 qualifying device matching the description provided when estimate was made. Sales tax may 
                 be assessed on full value of a new device purchase. In-store trade-in requires presentation 
                 of a valid photo ID (local law may require saving this information). Offer may not be available
                  in all stores, and may vary between in-store and online trade-in. Some stores may have additional 
                  requirements. Apple or its trade-in partners reserve the right to refuse or limit quantity of any
                   trade-in transaction for any reason. More details are available from Apple’s trade-in partner for 
                   trade-in and recycling of eligible devices. Restrictions and limitations may apply.
                Available in the U.S. on apple.com, in the Apple Store app, and at Apple Stores</p>   
                <p>Available in the U.S. on <a href='apple.com'>apple.com</a>, in the Apple Store app, and at Apple Stores.<br/><br/>
                To access and use all Apple Card features and products available only to Apple Card users, you must add Apple Card to Wallet on an iPhone or iPad that supports and has the latest version of iOS or iPadOS. Apple Card is subject to credit approval, available only for qualifying applicants in the United States, and issued by Goldman Sachs Bank USA, Salt Lake City Branch.
                <br/><br/>
                
If you reside in the U.S. territories, please call Goldman Sachs at 877-255-5923 with questions about Apple Card.
                <br/><br/>
                Learn more about how Apple Card applications are evaluated at support.<a href='https://support.apple.com/en-us/102585'>apple.com/kb/HT209218</a>.
               <br/><br/>
               A subscription is required for Apple TV+.
               </p>
                </div>
                <div className="footer-links-wrapper row">
                    <div className="links-wrapper-1 col-sm-12 col-md">
                        <h3>Shop and Learn</h3>
                        <ul>
                            <li><a href="#">Mac</a></li>
                            <li><a href="#">iPad</a></li>
                            <li><a href="#">iPhone</a></li>
                            <li><a href="#">Watch</a></li>
                            <li><a href="#">TV</a></li>
                            <li><a href="#">Music</a></li>
                            <li><a href="#">AirPods</a></li>
                            <li><a href="#">HomePod</a></li>
                            <li><a href="#">iPod touch</a></li>
                            <li><a href="#">Accessories</a></li>
                            <li><a href="#">Gift Cards</a></li>
                        </ul>
                    </div>
                    <div className="links-wrapper-2 col-sm-12 col-md">
                        <h3>Services</h3>
                        <ul>
                            <li><a href="#">Apple Music</a></li>
                            <li><a href="#">Apple News+</a></li>
                            <li><a href="#">Apple TV+</a></li>
                            <li><a href="#">Apple Arcade</a></li>
                            <li><a href="#">Apple Card</a></li>
                            <li><a href="#">iCloud</a></li>
                        </ul>
                        <h3>Account</h3>
                        <ul>
                            <li><a href="#">Manage Your Apple ID</a></li>
                            <li><a href="#">Apple Store Account</a></li>
                            <li><a href="#">iCloud.com</a></li>
                        </ul>
                    </div>
                    <div className="links-wrapper-3 col-sm-12 col-md">
                        <h3>Apple Store</h3>
                        <ul>
                            <li><a href="#">Find a Store</a></li>
                            <li><a href="#">Genius Bar</a></li>
                            <li><a href="#">Today at Apple</a></li>
                            <li><a href="#">Apple Camp</a></li>
                            <li><a href="#">Field Trip</a></li>
                            <li><a href="#">Apple Store App</a></li>
                            <li><a href="#">Refurbished and Clearance</a></li>
                            <li><a href="#">Financing</a></li>
                            <li><a href="#">Apple Trade In</a></li>
                            <li><a href="#">Order Status</a></li>
                            <li><a href="#">Shopping Help</a></li>
                        </ul>
                    </div>
                    <div className="links-wrapper-4 col-sm-12 col-md">
                        <h3>For Business</h3>
                        <ul>
                            <li><a href="#">Apple and Business</a></li>
                            <li><a href="#">Shop for Business</a></li>
                        </ul>
                        <h3>For Education</h3>
                        <ul>
                            <li><a href="#">Apple and Education</a></li>
                            <li><a href="#">Shop for College</a></li>
                        </ul>
                        <h3>For Healthcare</h3>
                        <ul>
                            <li><a href="#">Manage Your Apple ID</a></li>
                            <li><a href="#">Apple Store Account</a></li>
                            <li><a href="#">iCloud.com</a></li>
                        </ul>
                        <h3>For Government</h3>
                        <ul>
                            <li><a href="#">Apple and Education</a></li>
                            <li><a href="#">Shop for College</a></li>
                        </ul>
                    </div>
                    <div className="links-wrapper-5 col-sm-12 col-md">
                        <h3>Apple Values</h3>
                        <ul>
                            <li><a href="#">Find a Store</a></li>
                            <li><a href="#">Genius Bar</a></li>
                            <li><a href="#">Today at Apple</a></li>
                            <li><a href="#">Apple Camp</a></li>
                            <li><a href="#">Field Trip</a></li>
                            <li><a href="#">Apple Store App</a></li>
                        </ul>
                        <h3>About Apple</h3>
                        <ul>
                            <li><a href="#">Find a Store</a></li>
                            <li><a href="#">Genius Bar</a></li>
                            <li><a href="#">Today at Apple</a></li>
                            <li><a href="#">Apple Camp</a></li>
                            <li><a href="#">Field Trip</a></li>
                            <li><a href="#">Apple Store App</a></li>
                        </ul>
                    </div>
                </div>
                <div className="my-apple-wrapper">
                    More ways to shop: <a href="#">Find an Apple Store</a> or <a href="#">other retailer</a> near you. Or call 1-800-MY-APPLE.
                </div>
                <div className="copyright-wrapper row">
                    <div className="copyright col-sm-12 order-2 col-md-8 order-md-1 col-lg-4 order-lg-1">
                        Copyright &copy; 2020 Apple Inc. All rights reserved.
                    </div>
                    <div className="footer-links-terms  col-sm-12 order-3 col-lg-6 order-lg-2">
                        <ul>
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Terms of Use</a></li>
                            <li><a href="#">Sales and Refunds</a></li>
                            <li><a href="#">Legal</a></li>
                            <li><a href="#">Site Map</a></li>
                        </ul>
                    </div>
                    <div className="footer-country  col-sm-12 order-1 col-md-4 order-md-2 text-md-right col-lg-2 order-lg-3">
                        <div className="flag-wrapper"><img src={usa} alt="flag"/></div> <div className="footer-country-name">United States</div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
